import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Shipping_policy.css";
import { useEffect } from "react";
import { FaChevronUp } from "react-icons/fa6";
import { FaChevronDown } from "react-icons/fa";
const ShippingPolicy = () => {

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const fben = {
    "1": "Shipping Policy",
    "2": "Home"
  }
  const fbhi = {

    "1": "शिपिंग नीति",
    "2": "होम"

  }
  const fbka = {
    "1": "ಸಾಗಣೆ ನೀತಿ",
    "2": "ಮರಳಿ ಪ್ರಥಮ ಪುಟಕ್ಕೆ"
  }

  const fbte = {
    "1": "రవాణా విధానం",
    "2": "హోం"
  }
  const fbta = {
    "1": "கப்பல் கொள்கை",
    "2": "முகப்புப் பக்கம்"
  }
  const shippingen = [
    {
      title: "Shipping Locations", content: [
        "We currently ship to locations within India and Internationally.",
        "If your location is not serviceable, we will notify you during the checkout process.",
        "International shipping is available for select products. Contact us for details."
      ]
    },
    {
      title: "Shipping Charges", content: [
        "Domestic Shipping: Free shipping on orders above ₹2000.",
        "International Shipping: Calculated based on destination, weight, and size of the package.",
        "Shipping charges (if any) will be displayed at checkout before you place your order."
      ]
    },
    {
      title: "Delivery Timeline", content: [
        "Processing Time: Orders are typically processed within 1-2 business days.",
        "Estimated Delivery Time:",
        "Metro Cities: 1-2 days",
        "Non-Metro Cities: 2-4 days",
        "International: 1 week to 10 days"
      ]
    },
    { title: "Order Tracking", content: ["Once your order is shipped, we will provide you with a tracking ID via email or SMS."] },
    {
      title: "Delivery Attempts", content: [
        "Our delivery partner will attempt 3-4 deliveries before returning the package to us.",
        "If the delivery fails due to an incorrect address or unavailability, additional charges may apply for re-shipping."
      ]
    },
    {
      title: "Packaging", content: [
        "We ensure secure packaging of all orders to protect them during transit.",
        "If you notice any damage to the package upon delivery, please refuse to accept it, take a photograph or video proof, and inform us immediately."
      ]
    },
    {
      title: "Delayed or Missed Deliveries", content: [
        "While we strive to deliver within the estimated timeframe, delays may occur due to external factors.",
        "If your order is delayed, please contact us at support@terrainternational.in, and we will assist you."
      ]
    },
    {
      title: "Undeliverable Packages", content: [
        "Incorrect or incomplete address.",
        "Customer unavailability.",
        "Restricted shipping zone.",
        "In such cases, the order will be cancelled, and a refund (excluding shipping fees) will be processed as per our Refund Policy."
      ]
    },
    {
      title: "International Shipping", content: [
        "Customs clearance is the responsibility of the customer.",
        "Any additional duties, taxes, or fees levied by the destination country will be borne by the customer.",
        "Delays caused by customs are beyond our control."
      ]
    },
    {
      title: "Changes to Shipping Address", content: [
        "Changes to the shipping address can be requested within 24 hours of placing the order.",
        "Contact us at support@terrainternational.in for assistance."
      ]
    },
    {
      title: "Contact Us", content: [
        "For shipping-related inquiries or issues, please reach out to us: ",
        "Email: support@terrainternational.in ",
        " Phone: 7022519222"
      ]
    },
  ]
  const shippingte = [
    {
      "title": "రవాణా ప్రదేశాలు", "content": [
        "మేము ప్రస్తుతం భారతదేశం మరియు అంతర్జాతీయంగా రవాణా చేస్తాము. ",
        "మీ ప్రదేశం సేవలందించదగినదా లేదా అనేది చెక్అవుట్ ప్రక్రియలో మీకు తెలియజేస్తాము. ",
        "కొన్ని ఉత్పత్తులకు మాత్రమే అంతర్జాతీయ రవాణా అందుబాటులో ఉంటుంది. మరిన్ని వివరాలకు మమ్మల్ని సంప్రదించండి."
      ]
    },
    {
      "title": "రవాణా ఖర్చులు", "content": [
        "దేశీయ రవాణా: ₹2000 కంటే ఎక్కువ ఆర్డర్లకు ఉచిత రవాణా. ",
        "అంతర్జాతీయ రవాణా: గమ్యం, బరువు మరియు పార్శిల్ పరిమాణంపై ఆధారపడి లెక్కించబడుతుంది. ",
        "రవాణా ఖర్చులు (ఉండినట్లయితే) చెక్అవుట్‌లో మీ ఆర్డర్ ఉంచే ముందు ప్రదర్శించబడతాయి."
      ]
    },
    {
      "title": "డెలివరీ సమయం", "content": [
        "ప్రాసెసింగ్ సమయం: ఆర్డర్లు సాధారణంగా 1-2 వ్యాపార రోజుల్లో ప్రాసెస్ చేయబడతాయి. ",
        "అంచనా డెలివరీ సమయం: ",
        "మెట్రో నగరాలు: 1-2 రోజులు ",
        "నాన్-మెట్రో నగరాలు: 2-4 రోజులు ",
        "అంతర్జాతీయ: 1 వారం నుండి 10 రోజులు "
      ]
    },
    { "title": "ఆర్డర్ ట్రాకింగ్", "content": ["మీ ఆర్డర్ రవాణా అయిన వెంటనే, మేము మీకు ట్రాకింగ్ ఐడి ఇమెయిల్ లేదా SMS ద్వారా అందిస్తాము."] },
    {
      "title": "డెలివరీ ప్రయత్నాలు", "content": [
        "మా డెలివరీ భాగస్వామి 3-4 సార్లు డెలివరీ ప్రయత్నించి, విజయవంతం కాకపోతే పార్శిల్ మాకు తిరిగి పంపబడుతుంది. ",
        "తప్పు చిరునామా లేదా లభ్యత లేని కారణంగా డెలివరీ విఫలమైతే, తిరిగి పంపించడానికి అదనపు ఛార్జీలు వర్తించవచ్చు."
      ]
    },
    {
      "title": "ప్యాకేజింగ్", "content": [
        "రవాణా సమయంలో మీ ఆర్డర్ సురక్షితంగా ఉండేలా మేము గట్టి ప్యాకేజింగ్‌ను అందిస్తున్నాము. ",
        "డెలివరీ సమయంలో ప్యాకేజింగ్ దెబ్బతిన్నట్లు గమనిస్తే, దయచేసి స్వీకరించకుండా తిరస్కరించండి, ఫోటో లేదా వీడియో తీసి మమ్మల్ని వెంటనే సంప్రదించండి."
      ]
    },
    {
      "title": "ఆలస్యం లేదా మిస్ అయిన డెలివరీలు", "content": [
        "మేము అంచనా సమయంలో డెలివరీ చేయడానికి ప్రయత్నిస్తాం, కానీ బాహ్య కారణాల వల్ల ఆలస్యం సంభవించవచ్చు. ",
        "మీ ఆర్డర్ ఆలస్యమైతే, support@terrainternational.in లో మమ్మల్ని సంప్రదించండి, మేము మీకు సహాయపడతాం."
      ]
    },
    {
      "title": "డెలివరీ చేయలేని పార్శిల్స్", "content": [
        "తప్పు లేదా అసంపూర్ణ చిరునామా. ",
        "కస్టమర్ లభ్యత లేదు. ",
        "నిషేధిత రవాణా ప్రాంతం. ",
        "ఇలాంటి సందర్భాల్లో, ఆర్డర్ రద్దు చేయబడుతుంది మరియు మా రిఫండ్ పాలసీ ప్రకారం రవాణా ఖర్చులు మినహాయించి రిఫండ్ ప్రాసెస్ చేయబడుతుంది."
      ]
    },
    {
      "title": "అంతర్జాతీయ రవాణా", "content": [
        "కస్టమ్స్ క్లియరెన్స్ బాధ్యత కస్టమర్‌దే. ",
        "గమ్యదేశ దేశం విధించే అదనపు కస్టమ్ డ్యూటీలు, పన్నులు లేదా ఫీజులను కస్టమర్ భరించాలి. ",
        "కస్టమ్స్ కారణంగా డెలివరీ ఆలస్యమైతే, అది మా నియంత్రణలో లేదు."
      ]
    },
    {
      "title": "రవాణా చిరునామా మార్పులు", "content": [
        "ఆర్డర్ పెట్టిన 24 గంటలలోపు రవాణా చిరునామా మార్పులు అభ్యర్థించవచ్చు. ",
        "సహాయానికి support@terrainternational.in లో మమ్మల్ని సంప్రదించండి."
      ]
    },
    {
      "title": "మమ్మల్ని సంప్రదించండి", "content": [
        "రవాణా సంబంధిత ప్రశ్నలు లేదా సమస్యల కోసం, దయచేసి మమ్మల్ని సంప్రదించండి: ",
        "ఇమెయిల్: support@terrainternational.in ",
        "ఫోన్: 7022519222"
      ]
    }
  ]
  const shippingta = [
    {
      "title": "அனுப்பும் இடங்கள்", "content": [
        "நாங்கள் தற்போது இந்தியாவிற்குள் மற்றும் சர்வதேச அளவில் இடங்களுக்கு அனுப்புகிறோம். உங்கள் இடம் சேவை செய்ய முடியாததாக இருந்தால், செக்அவுட் செயல்முறையின் போது உங்களுக்குத் தெரிவிப்போம். தேர்ந்தெடுக்கப்பட்ட தயாரிப்புகளுக்கு சர்வதேச ஷிப்பிங் கிடைக்கிறது. விவரங்களுக்கு எங்களைத் தொடர்பு கொள்ளவும்."
      ]
    },
    {
      "title": "கப்பல் கட்டணங்கள்", "content": [
        "உள்நாட்டு ஷிப்பிங்: ₹2000க்கு மேல் ஆர்டர்களுக்கு இலவச ஷிப்பிங். சர்வதேச ஷிப்பிங்: சேருமிடம், எடை மற்றும் பார்சலின் அளவு ஆகியவற்றின் அடிப்படையில் கணக்கிடப்படுகிறது. நீங்கள் ஆர்டர் செய்வதற்கு முன் செக் அவுட்டில் ஷிப்பிங் கட்டணங்கள் (ஏதேனும் இருந்தால்) காட்டப்படும்."
      ]
    },
    {
      "title": "டெலிவரி காலவரிசை", "content": [
        "செயலாக்க நேரம்: ஆர்டர்கள் பொதுவாக 1-2 வணிக நாட்களுக்குள் செயல்படுத்தப்படும். மதிப்பிடப்பட்ட டெலிவரி நேரம்: பெருநகர நகரங்கள்: 1-2 நாட்கள் பெருநகரம் அல்லாத நகரங்கள்: 2-4 நாட்கள் சர்வதேசம்: 1 வாரம் முதல் 10 நாட்கள் வரை"
      ]
    },
    { "title": "ஆர்டர் கண்காணிப்பு", "content": ["உங்கள் ஆர்டர் அனுப்பப்பட்டவுடன், மின்னஞ்சல் அல்லது குறுஞ்செய்தி மூலம் கண்காணிப்பு ஐடியை நாங்கள் உங்களுக்கு வழங்குவோம்."] },
    {
      "title": "டெலிவரி முயற்சிகள்", "content": [
        "எங்கள் டெலிவரி பார்ட்னர் 3-4 டெலிவரிகளை முயற்சித்து பார்சலை எங்களிடம் திருப்பி அனுப்புவார். தவறான முகவரி அல்லது கிடைக்காததால் டெலிவரி தோல்வியடைந்தால், மறு ஷிப்பிங்கிற்கு கூடுதல் கட்டணங்கள் விதிக்கப்படலாம்."
      ]
    },
    {
      "title": "பேக்கேஜிங்", "content": [
        "போக்குவரத்தின் போது அனைத்து ஆர்டர்களையும் பாதுகாக்க, அனைத்து ஆர்டர்களையும் பாதுகாப்பாக பேக்கேஜிங் செய்வதை நாங்கள் உறுதிசெய்கிறோம். டெலிவரி செய்யும்போது பார்சலில் ஏதேனும் சேதம் ஏற்பட்டால், அதை ஏற்க மறுத்து, புகைப்படம் அல்லது வீடியோ ஆதாரத்தை எடுத்து, உடனடியாக எங்களுக்குத் தெரிவிக்கவும்."
      ]
    },
    {
      "title": "தாமதமான அல்லது தவறவிட்ட டெலிவரி", "content": [
        "மதிப்பிடப்பட்ட காலக்கெடுவிற்குள் டெலிவரி செய்ய நாங்கள் பாடுபடுகிறோம், ஆனால் வெளிப்புற காரணிகளால் தாமதங்கள் ஏற்படலாம். உங்கள் ஆர்டர் தாமதமானால், support@terrainternational.in என்ற முகவரியில் எங்களைத் தொடர்பு கொள்ளவும், நாங்கள் உங்களுக்கு உதவுவோம்."
      ]
    },
    {
      "title": "வழங்க முடியாத தொகுப்புகள்", "content": [
        "தவறான அல்லது முழுமையற்ற முகவரி. வாடிக்கையாளர் கிடைக்கவில்லை. தடைசெய்யப்பட்ட ஷிப்பிங் மண்டலம். இதுபோன்ற சந்தர்ப்பங்களில், ஆர்டர் ரத்து செய்யப்படும், மேலும் எங்கள் பணத்தைத் திரும்பப்பெறும் கொள்கையின்படி (கப்பல் கட்டணங்களைத் தவிர்த்து) பணத்தைத் திரும்பப் பெறுதல் செயல்படுத்தப்படும்."
      ]
    },
    {
      "title": "சர்வதேச கப்பல் போக்குவரத்து", "content": [
        "சுங்க அனுமதி என்பது வாடிக்கையாளரின் பொறுப்பாகும். சேருமிட நாட்டால் விதிக்கப்படும் கூடுதல் வரிகள், வரிகள் அல்லது கட்டணங்கள் வாடிக்கையாளரால் ஏற்கப்படும். சுங்கத்தால் ஏற்படும் தாமதங்கள் எங்கள் கட்டுப்பாட்டிற்கு அப்பாற்பட்டவை."
      ]
    },
    {
      "title": "ஷிப்பிங் முகவரியில் மாற்றங்கள்", "content": [
        "ஆர்டர் செய்த 24 மணி நேரத்திற்குள் ஷிப்பிங் முகவரியில் மாற்றங்களைக் கோரலாம். உதவிக்கு support@terrainternational.in என்ற மின்னஞ்சல் முகவரியில் எங்களைத் தொடர்பு கொள்ளவும்."
      ]
    },
    {
      "title": "எங்களை தொடர்பு கொள்ள", "content": [
        "கப்பல் போக்குவரத்து தொடர்பான விசாரணைகள் அல்லது சிக்கல்களுக்கு, தயவுசெய்து எங்களைத் தொடர்பு கொள்ளவும்: மின்னஞ்சல்: support@terrainternational.in தொலைபேசி: 7022519222."
      ]
    }
  ]
  const shippingka = [
    {
      title: "ಶಿಪ್ಪಿಂಗ್ ಸ್ಥಳಗಳು", content: [
        "ನಾವು ಪ್ರಸ್ತುತ ಭಾರತ ಮತ್ತು ಅಂತರಾಷ್ಟ್ರೀಯ ಸ್ಥಳಗಳಿಗೆ ರವಾನೆ ಮಾಡುತ್ತೇವೆ. ನಿಮ್ಮ ಸ್ಥಳವು ಸೇವೆ ಸಲ್ಲಿಸಲು ಸಾಧ್ಯವಾಗದಿದ್ದರೆ, ಚೆಕ್‌ಔಟ್ ಪ್ರಕ್ರಿಯೆಯ ಸಮಯದಲ್ಲಿ ನಾವು ನಿಮಗೆ ಸೂಚಿಸುತ್ತೇವೆ. ಆಯ್ದ ಉತ್ಪನ್ನಗಳಿಗೆ ಅಂತರಾಷ್ಟ್ರೀಯ ಶಿಪ್ಪಿಂಗ್ ಲಭ್ಯವಿದೆ. ವಿವರಗಳಿಗಾಗಿ ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ."
      ]
    },
    {
      title: "ಶಿಪ್ಪಿಂಗ್ ಶುಲ್ಕಗಳು", content: [
        "ದೇಶೀಯ ಶಿಪ್ಪಿಂಗ್: ₹2000 ಕ್ಕಿಂತ ಹೆಚ್ಚಿನ ಆರ್ಡರ್‌ಗಳಿಗೆ ಉಚಿತ ಶಿಪ್ಪಿಂಗ್.",
        "ಅಂತರರಾಷ್ಟ್ರೀಯ ಶಿಪ್ಪಿಂಗ್: ಗಮ್ಯಸ್ಥಾನ, ತೂಕ ಮತ್ತು ಪ್ಯಾಕೇಜ್‌ನ ಗಾತ್ರವನ್ನು ಆಧರಿಸಿ ಲೆಕ್ಕಹಾಕಲಾಗುತ್ತದೆ.",
        "ನೀವು ಆರ್ಡರ್ ಮಾಡುವ ಮೊದಲು ಶಿಪ್ಪಿಂಗ್ ಶುಲ್ಕಗಳು (ಯಾವುದಾದರೂ ಇದ್ದರೆ) ಚೆಕ್‌ಔಟ್‌ನಲ್ಲಿ ಪ್ರದರ್ಶಿಸಲಾಗುತ್ತದೆ."
      ]
    },
    {
      title: "ವಿತರಣಾ ಟೈಮ್‌ಲೈನ್", content: [
        "ಪ್ರಕ್ರಿಯೆ ಸಮಯ: ಆರ್ಡರ್‌ಗಳನ್ನು ಸಾಮಾನ್ಯವಾಗಿ 1-2 ವ್ಯವಹಾರ ದಿನಗಳಲ್ಲಿ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತದೆ.",
        "ಅಂದಾಜು ವಿತರಣಾ ಸಮಯ:",
        "ಮೆಟ್ರೋ ನಗರಗಳು: 1-2 ದಿನಗಳು",
        "ಮೆಟ್ರೋ ಅಲ್ಲದ ನಗರಗಳು: 2-4 ದಿನಗಳು",
        "ಅಂತರರಾಷ್ಟ್ರೀಯ: 1 ವಾರದಿಂದ 10 ದಿನಗಳು"
      ]
    },
    {
      title: "ಆರ್ಡರ್ ಟ್ರ್ಯಾಕಿಂಗ್", content: [
        "ನಿಮ್ಮ ಆದೇಶವನ್ನು ರವಾನಿಸಿದ ನಂತರ, ಇಮೇಲ್ ಅಥವಾ SMS ಮೂಲಕ ನಾವು ನಿಮಗೆ ಟ್ರ್ಯಾಕಿಂಗ್ ಐಡಿಯನ್ನು ಒದಗಿಸುತ್ತೇವೆ."
      ]
    },
    {
      title: "ವಿತರಣಾ ಪ್ರಯತ್ನಗಳು", content: [
        "ಪ್ಯಾಕೇಜ್ ಅನ್ನು ನಮಗೆ ಹಿಂದಿರುಗಿಸುವ ಮೊದಲು ನಮ್ಮ ವಿತರಣಾ ಪಾಲುದಾರರು 3-4 ವಿತರಣೆಗಳನ್ನು ಪ್ರಯತ್ನಿಸುತ್ತಾರೆ.",
        "ತಪ್ಪಾದ ವಿಳಾಸ ಅಥವಾ ಅಲಭ್ಯತೆಯ ಕಾರಣದಿಂದಾಗಿ ವಿತರಣೆಯು ವಿಫಲವಾದಲ್ಲಿ, ಮರು-ಶಿಪ್ಪಿಂಗ್‌ಗೆ ಹೆಚ್ಚುವರಿ ಶುಲ್ಕಗಳು ಅನ್ವಯಿಸಬಹುದು."
      ]
    },
    {
      title: "ಪ್ಯಾಕೇಜಿಂಗ್", content: [
        "ಸಾಗಣೆಯ ಸಮಯದಲ್ಲಿ ಅವುಗಳನ್ನು ರಕ್ಷಿಸಲು ಎಲ್ಲಾ ಆರ್ಡರ್‌ಗಳ ಸುರಕ್ಷಿತ ಪ್ಯಾಕೇಜಿಂಗ್ ಅನ್ನು ನಾವು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳುತ್ತೇವೆ.",
        "ವಿತರಣೆಯ ನಂತರ ಪ್ಯಾಕೇಜ್‌ಗೆ ಯಾವುದೇ ಹಾನಿಯನ್ನು ನೀವು ಗಮನಿಸಿದರೆ, ದಯವಿಟ್ಟು ಅದನ್ನು ಸ್ವೀಕರಿಸಲು ನಿರಾಕರಿಸಿ, ಛಾಯಾಚಿತ್ರ ಅಥವಾ ವೀಡಿಯೊ ಪುರಾವೆ ತೆಗೆದುಕೊಳ್ಳಿ ಮತ್ತು ತಕ್ಷಣವೇ ನಮಗೆ ತಿಳಿಸಿ."
      ]
    },
    {
      title: "ವಿಳಂಬಗೊಂಡ ಅಥವಾ ತಪ್ಪಾದ ವಿತರಣೆಗಳು", content: [
        "ನಾವು ಅಂದಾಜು ಸಮಯದ ಚೌಕಟ್ಟಿನೊಳಗೆ ತಲುಪಿಸಲು ಪ್ರಯತ್ನಿಸುತ್ತಿರುವಾಗ, ಬಾಹ್ಯ ಅಂಶಗಳಿಂದ ವಿಳಂಬಗಳು ಸಂಭವಿಸಬಹುದು.",
        "ನಿಮ್ಮ ಆರ್ಡರ್ ವಿಳಂಬವಾಗಿದ್ದರೆ, ದಯವಿಟ್ಟು support@terrainternational.in ನಲ್ಲಿ ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ ಮತ್ತು ನಾವು ನಿಮಗೆ ಸಹಾಯ ಮಾಡುತ್ತೇವೆ."
      ]
    },
    {
      title: "ವಿತರಿಸಲಾಗದ ಪ್ಯಾಕೇಜ್‌ಗಳು", content: [
        "ಸರಿಯಾದ ಅಥವಾ ಅಪೂರ್ಣ ವಿಳಾಸ.",
        "ಗ್ರಾಹಕರ ಅಲಭ್ಯತೆ.",
        "ನಿರ್ಬಂಧಿತ ಶಿಪ್ಪಿಂಗ್ ವಲಯ.",
        "ಅಂತಹ ಸಂದರ್ಭಗಳಲ್ಲಿ, ಆದೇಶವನ್ನು ರದ್ದುಗೊಳಿಸಲಾಗುತ್ತದೆ ಮತ್ತು ನಮ್ಮ ಮರುಪಾವತಿ ನೀತಿಯ ಪ್ರಕಾರ ಮರುಪಾವತಿಯನ್ನು (ಶಿಪ್ಪಿಂಗ್ ಶುಲ್ಕವನ್ನು ಹೊರತುಪಡಿಸಿ) ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತದೆ."
      ]
    },
    {
      title: "ಅಂತರರಾಷ್ಟ್ರೀಯ ಶಿಪ್ಪಿಂಗ್", content: [
        "ಕಸ್ಟಮ್ಸ್ ಕ್ಲಿಯರೆನ್ಸ್ ಗ್ರಾಹಕರ ಜವಾಬ್ದಾರಿಯಾಗಿದೆ.",
        "ಗಮ್ಯಸ್ಥಾನದ ದೇಶದಿಂದ ವಿಧಿಸಲಾದ ಯಾವುದೇ ಹೆಚ್ಚುವರಿ ಸುಂಕಗಳು, ತೆರಿಗೆಗಳು ಅಥವಾ ಶುಲ್ಕಗಳನ್ನು ಗ್ರಾಹಕರು ಭರಿಸಬೇಕಾಗುತ್ತದೆ.",
        "ಕಸ್ಟಮ್ಸ್‌ನಿಂದ ಉಂಟಾಗುವ ವಿಳಂಬಗಳು ನಮ್ಮ ನಿಯಂತ್ರಣಕ್ಕೆ ಮೀರಿವೆ."
      ]
    },
    {
      title: "ಶಿಪ್ಪಿಂಗ್ ವಿಳಾಸ ಬದಲಾವಣೆಗಳು", content: [
        "ಆರ್ಡರ್ ಮಾಡಿದ 24 ಗಂಟೆಗಳ ಒಳಗೆ ಶಿಪ್ಪಿಂಗ್ ವಿಳಾಸಕ್ಕೆ ಬದಲಾವಣೆಗಳನ್ನು ವಿನಂತಿಸಬಹುದು.",
        "ಸಹಾಯಕ್ಕಾಗಿ support@terrainternational.in ನಲ್ಲಿ ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ."
      ]
    },
    {
      title: "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ", content: [
        "ಶಿಪ್ಪಿಂಗ್-ಸಂಬಂಧಿತ ವಿಚಾರಣೆಗಳು ಅಥವಾ ಸಮಸ್ಯೆಗಳಿಗಾಗಿ, ದಯವಿಟ್ಟು ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ:",
        "ಇಮೇಲ್: support@terrainternational.in",
        "ಫೋನ್: 7022519222"
      ]
    }
  ];
  const shippinghi = [
    {
      "title": "शिपिंग स्थान",
      "content": [
        "हम वर्तमान में भारत और अंतरराष्ट्रीय स्तर पर शिपिंग करते हैं।",
        "यदि आपका स्थान सेवा योग्य नहीं है, तो आपको चेकआउट प्रक्रिया के दौरान सूचित किया जाएगा।",
        "कुछ उत्पादों के लिए अंतरराष्ट्रीय शिपिंग उपलब्ध है। अधिक जानकारी के लिए हमसे संपर्क करें।"
      ]
    },
    {
      "title": "शिपिंग शुल्क",
      "content": [
        "घरेलू शिपिंग: ₹2000 से अधिक के ऑर्डर पर मुफ्त शिपिंग।",
        "अंतरराष्ट्रीय शिपिंग: गंतव्य, वजन और पैकेज के आकार के आधार पर शुल्क लगाया जाएगा।",
        "शिपिंग शुल्क (यदि लागू हो) चेकआउट से पहले दिखाया जाएगा।"
      ]
    },
    {
      "title": "डिलीवरी समयरेखा",
      "content": [
        "प्रोसेसिंग समय: ऑर्डर आमतौर पर 1-2 कार्य दिवसों में संसाधित किए जाते हैं।",
        "अनुमानित डिलीवरी समय:",
        "मेट्रो शहर: 1-2 दिन",
        "गैर-मेट्रो शहर: 2-4 दिन",
        "अंतरराष्ट्रीय: 1 सप्ताह से 10 दिन"
      ]
    },
    {
      "title": "ऑर्डर ट्रैकिंग",
      "content": [
        "एक बार आपका ऑर्डर शिप होने के बाद, हम आपको ईमेल या एसएमएस के माध्यम से एक ट्रैकिंग आईडी प्रदान करेंगे।"
      ]
    },
    {
      "title": "डिलीवरी प्रयास",
      "content": [
        "हमारा डिलीवरी पार्टनर 3-4 बार डिलीवरी का प्रयास करेगा, इसके बाद पैकेज हमें वापस कर दिया जाएगा।",
        "यदि गलत पते या ग्राहक की अनुपलब्धता के कारण डिलीवरी असफल होती है, तो पुनः शिपिंग के लिए अतिरिक्त शुल्क लग सकता है।"
      ]
    },
    {
      "title": "पैकेजिंग",
      "content": [
        "हम यह सुनिश्चित करते हैं कि सभी ऑर्डर सुरक्षित पैकेजिंग में भेजे जाएं ताकि वे ट्रांज़िट के दौरान सुरक्षित रहें।",
        "यदि डिलीवरी के समय पैकेज में कोई क्षति हो तो उसे स्वीकार न करें, उसकी फ़ोटो या वीडियो प्रमाण लें और तुरंत हमें सूचित करें।"
      ]
    },
    {
      "title": "डिलीवरी में देरी या चूक",
      "content": [
        "हम अपने निर्धारित समय के भीतर डिलीवरी करने का पूरा प्रयास करते हैं, लेकिन बाहरी कारणों से कभी-कभी देरी हो सकती है।",
        "यदि आपका ऑर्डर देरी से है, तो कृपया हमसे support@terrainternational.in पर संपर्क करें।"
      ]
    },
    {
      "title": "अप्राप्य (Undeliverable) पैकेज",
      "content": [
        "गलत या अधूरा पता।",
        "ग्राहक की अनुपलब्धता।",
        "प्रतिबंधित शिपिंग क्षेत्र।",
        "इन मामलों में, ऑर्डर रद्द कर दिया जाएगा और शिपिंग शुल्क को छोड़कर शेष राशि को हमारी रिफंड नीति के अनुसार वापस कर दिया जाएगा।"
      ]
    },
    {
      "title": "अंतरराष्ट्रीय शिपिंग",
      "content": [
        "सीमा शुल्क (Customs Clearance) ग्राहक की ज़िम्मेदारी होगी।",
        "गंतव्य देश द्वारा लगाए गए कोई भी अतिरिक्त शुल्क, कर या फीस ग्राहक को वहन करनी होगी।",
        "सीमा शुल्क प्रक्रिया के कारण होने वाली देरी हमारे नियंत्रण से बाहर होती है।"
      ]
    },
    {
      "title": "शिपिंग पते में परिवर्तन",
      "content": [
        "ऑर्डर देने के 24 घंटे के भीतर शिपिंग पते में परिवर्तन का अनुरोध किया जा सकता है।",
        "सहायता के लिए support@terrainternational.in पर संपर्क करें।"
      ]
    },
    {
      "title": "संपर्क करें",
      "content": [
        "यदि आपको शिपिंग से संबंधित कोई भी प्रश्न या समस्या हो, तो कृपया हमसे संपर्क करें:",
        "ईमेल: support@terrainternational.in",
        "फोन: 7022519222"
      ]
    }
  ]

  const [fb, setFB] = useState(fben)
  const [shipping, setHomeen] = useState(shippingen)

  useEffect(() => {
    const storedLanguage = localStorage.getItem("selectedLanguage") || "en";
    switch (storedLanguage) {
      case "kn":
        setHomeen(shippingka);
        setFB(fbka);
        break;
      case "te":
        setHomeen(shippingte);
        setFB(fbte);
        break;
      case "ta":
        setHomeen(shippingta);
        setFB(fbta);
        break;
      case "hi":
        setHomeen(shippinghi);
        setFB(fbhi);
        break;
      default:
        setHomeen(shippingen);
        setFB(fben);
    }

  }, []);

  return (
    <>
      <div className="breadcrumb-wrap bg-f br-2">
        <div className="container">
          <div className="breadcrumb-title">
            <h2>{fb["1"]}</h2>
            <ul className="breadcrumb-menu list-style">
              <li><Link to="/">{fb["2"]}</Link></li>
              <li>{fb["1"]}</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="faqs-container">
        <br />
        {/* <p>At <strong>TERRA CLENZ</strong>, we are committed to delivering your orders promptly and efficiently.</p> */}

        {shipping.map((section, index) => (
          <div className="faq" key={index}>
            <h6 onClick={() => toggleFAQ(index)} className="faq-question">
              {section.title} {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
            </h6>
            <div className={`faq-answer ${openIndex === index ? "open" : ""}`}>
              {openIndex === index && section.content}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ShippingPolicy;
